import { render, staticRenderFns } from "./LeaveRequestRejected.vue?vue&type=template&id=1d0e64aa"
import script from "./LeaveRequestRejected.vue?vue&type=script&lang=js"
export * from "./LeaveRequestRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports